export default "__VITE_ASSET__CPmFGJh7__"